import * as types from '../constants/actions';
import { makeAsyncReducer, asyncDefaults, mergeReducers } from '../../../ui-lottery/src/utils/async_utils';

const fetchFacilities = makeAsyncReducer(types.FETCH_FACILITIES);

const facilities = mergeReducers(asyncDefaults([]), types.PP_PREFIX, fetchFacilities);

export default facilities;

export const selectors = {
  getFacilities: (state) => state.parkpass.facilities.data
};
